import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { useEffect, useRef, useState, type FC } from "react";
import { FullScreenLoader } from "../../app/appStatusScreens.js";
import {
  completeServiceAccessSignIn,
  resumeServiceAccess,
} from "./serviceAccessClient.js";

/**
 * Where HQ sends the tab back with a code: exchanges it for this origin's
 * tokens, then loads the path the sign-in started from.
 */
export const ServiceAccessCallbackPage: FC = () => {
  const [hasFailed, setHasFailed] = useState(false);
  // The code is single-use; StrictMode's second effect run must not spend it.
  const hasStartedRef = useRef(false);

  useEffect(() => {
    if (hasStartedRef.current) {
      return;
    }
    hasStartedRef.current = true;
    completeServiceAccessSignIn().then(
      (returnPath) => window.location.replace(returnPath),
      (error: unknown) => {
        console.error("Service access sign-in failed:", error);
        setHasFailed(true);
      },
    );
  }, []);

  if (!hasFailed) {
    return <FullScreenLoader />;
  }

  return (
    <ServiceAccessSignInScreen>
      Signing in to service access failed.
    </ServiceAccessSignInScreen>
  );
};

export interface ServiceAccessSignInScreenProps {
  /** Why the session needs attention. */
  children: string;
}

/**
 * A full-screen message with a button that refreshes the session if it still
 * can, or starts the HQ sign-in again.
 */
export const ServiceAccessSignInScreen: FC<ServiceAccessSignInScreenProps> = (
  props,
) => {
  const { children } = props;
  return (
    <div className="flex h-screen flex-col items-center justify-center gap-4">
      <p className="text-center text-2xl text-foreground">{children}</p>
      <Button
        variant={ButtonVariant.Primary}
        onClick={() => void resumeServiceAccess()}
      >
        Continue
      </Button>
    </div>
  );
};
